import styled from '@emotion/styled'

export const LoadingContainer = styled.div`
	align-items: center;
	bottom: 0;
	display: flex;
	justify-content: center;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
`
